export default "__VITE_ASSET__BVj4zFJC__"